let server = "https://grants.nih.gov/guidesearch/api"
if(!window.location.href.includes("localhost")){
    server = "/guidesearch/api"
}
module.exports = server
